var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        title: _vm.$t("StockRules.Header.priority"),
        visible: _vm.dialogVisible,
        "destroy-on-close": "",
        width: "500px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("el-link", { attrs: { type: "warning", underline: false } }, [
        _vm._v(_vm._s(_vm.$t("StockRules.Main.Drag"))),
      ]),
      _c(
        "el-table",
        {
          ref: "multipleTable",
          staticClass: "channel-sort-table-20220304",
          attrs: {
            data: _vm.tableData,
            border: "",
            "header-cell-style": _vm.$rowStyle.DEFAULT,
            "row-key": "code",
            "row-class-name": "channel-sort-table-row-20220304",
          },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "name", label: _vm.$t("StockRules.Header.method") },
          }),
          _c(
            "el-table-column",
            {
              attrs: {
                prop: "code",
                label: _vm.$t("StockRules.Header.priorit"),
                "class-name": "draggableItem",
              },
            },
            [[_c("svg-icon", { attrs: { "icon-class": "pointer" } })]],
            2
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [
            _vm._v(_vm._s(_vm.$t("cancelText"))),
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.confirm } },
            [_vm._v(_vm._s(_vm.$t("okText")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }